<template>
    <div>
        <div v-if="lastPage != 1 && links.length > 1">
            <nav>
                <ul class="shop-pagination">
                    <!-- Previous page -->
                    <li v-if="coloredProducts.current_page > 1" class="shop-pagination-item prev">
                        <a
                            @click.prevent="fetchPage(coloredProducts.current_page - 1, coloredProducts.prev_page_url)"
                            :href="linkPrevHref"
                            :title="__('frontend_js.pagination.previous-unsigned')"
                            class="page-number page-number-prev no-underline"
                            rel="prev"
                        >
                            <span class="prev-next-text">{{ __('frontend_js.pagination.previous-unsigned') }}</span>
                        </a>
                    </li>

                    <!-- Pages with number -->
                    <template v-for="(link, index) in links">
                        <li :key="index" class="shop-pagination-item" :class="{ disabled: link.disabled, active: link.active }">
                            <span v-if="link.disabled || link.active">{{ link.label }}</span>
                            <a v-else @click.prevent="fetchPage(link.label, link.url)" :href="link.href" class="page-number">
                                {{ link.label }}
                            </a>
                        </li>
                    </template>

                    <!-- Next page -->
                    <li v-if="coloredProducts.current_page < lastPage" class="shop-pagination-item next">
                        <a
                            @click.prevent="fetchPage(coloredProducts.current_page + 1, coloredProducts.next_page_url)"
                            :href="linkNextHref"
                            :title="__('frontend_js.pagination.next-unsigned')"
                            class="page-number page-number-next no-underline"
                            rel="next"
                        >
                            <span class="prev-next-text">{{ __('frontend_js.pagination.next-unsigned') }}</span>
                        </a>
                    </li>
                </ul>
            </nav>
        </div>

        <div v-if="showThatsNotAllBtn">
            <div class="content-inner">
                <div class="subcategories-bottom-button subcategories-filter-reset">
                    <h2>{{ __('frontend_js.category.that-is-not-all') }}</h2>
                    <p>{{ __('frontend_js.category.see-them-all') }} {{ categoryTitle }} ({{ totalProducts }})</p>
                    <button class="text-uppercase shop-button spinnerButton" @click="cancelFilters">
                        <span>{{ categoryTitle }} ({{ totalProducts }})</span>
                    </button>
                </div>
            </div>
        </div>

        <div v-if="paginationLocation == 'bottom' && byModel == 'trademark'">
            <div class="content-inner">
                <trademark-thats-not-all-btn />
            </div>
        </div>
    </div>
</template>

<script>
import { nextTick } from 'vue';
import { mapGetters } from 'vuex';

export default {
    props: {
        byModel: { required: true },
        byModelId: { required: true },
        paginationLocation: { type: String, default: 'top' },
        categoryTitle: { type: String },
    },

    data() {
        return {
            linkPrevHref: '',
            linkNextHref: '',
            links: [],
        };
    },
    computed: {
        ...mapGetters('product-filters', ['orderString', 'queryFilters', 'filters', 'coloredProducts']),
        ...mapGetters('product-list', ['currentPage', 'totalProducts', 'nextPage', 'lastPage']),
        ...mapGetters('auth', ['check']),
        coloredProducts() {
            return this.$store.getters['product-list/coloredProducts'];
        },
        lastPageFromLastPageUrl() {
            return this.coloredProducts.last_page_url.split('=')[1] ?? 1;
        },
        baseUrl() {
            if (this.check) {
                if (this.byModel == 'category') return `/category-auth/${this.byModelId}`;
                if (this.byModel == 'search') return `search/${this.byModelId}`;
                if (this.byModel == 'trademark') return `trademarks/${this.byModelId}`;
            } else {
                if (this.byModel == 'category') return `/category/${this.byModelId}`;
                if (this.byModel == 'search') return `search/${this.byModelId}`;
                if (this.byModel == 'trademark') return `trademarks/${this.byModelId}`;
            }
        },
        showThatsNotAllBtn() {
            if (this.paginationLocation != 'bottom') return false;
            if (this.byModel != 'category') return false;
            if (this.queryFilters == '') return false;
            if (this.currentPage != this.lastPage) return false;
            if (this.totalProducts == this.coloredProducts.total) return false;

            return true;
        },
        finalLinks() {
            const links = [];
            let startMergeRequired = false;
            let endMergeRequired = false;
            let currentPage = parseInt(this.currentPage);
            let lastPage = parseInt(this.lastPage);
            if (this.lastPage > 9) {
                if (currentPage - 5 >= 1) startMergeRequired = true;
                if (currentPage + 5 <= lastPage) endMergeRequired = true;
            }
            for (let page = 1; page <= lastPage; page++) {
                let disabled = false;

                if (!startMergeRequired && endMergeRequired) {
                    if (page > 7 && page < lastPage) {
                        disabled = true;
                        page = lastPage - 1;
                    }
                }

                if (startMergeRequired && !endMergeRequired) {
                    if (page > 1 && page < lastPage - 7) {
                        disabled = true;
                        page = lastPage - 7;
                    }
                }

                if (startMergeRequired && endMergeRequired) {
                    if (page > 1 && page < currentPage - 2) {
                        disabled = true;
                        page = currentPage - 3;
                    }

                    if (page > currentPage + 2 && page < lastPage) {
                        disabled = true;
                        page = lastPage - 1;
                    }
                }

                links.push({
                    url: this.links.filter(link => parseInt(link.label) == page)[0].url,
                    active: page == currentPage,
                    label: disabled ? '...' : page,
                });
            }
            return links;
        },
    },
    created() {
        // this.$store.commit('product-list/SET_CURRENT_PAGE', this.coloredProducts.current_page);
        // console.log(this.coloredProducts.current_page);

        this.$root.$on('itemsLoaded', this.itemsLoaded);
    },
    watch: {
        coloredProducts: {
            handler(products) {
                if (products) {
                    this.setupLinks(products.current_page, this.lastPage);
                }
            },
        },
    },
    methods: {
        async fetchPage(page, url) {
            $('html, body').animate({ scrollTop: $('#filterWrapperForScrolling').offset().top }, 'slow');
            this.$store.commit('product-list/SET_LOADING', true);
            const response = await this.$store.dispatch('product-list/fetchElasticColoredProducts', { url: url });
            this.$root.$emit('paginated-products-fetched', response);
            this.$store.commit('product-list/SET_CURRENT_PAGE', page);
            if (this.byModel == this.$config.product_list_by_search) {
                const urlParams = new URLSearchParams(window.location.search);
                window.history.pushState(null, null, this.orderString + '?q=' + urlParams.get('q') + `&page=${this.currentPage}`);
            } else {
                window.history.pushState(null, null, '?' + this.orderString + `page=${this.currentPage}`);
            }
            this.$store.commit('product-list/SET_LOADING', false);
        },
        itemsLoaded(coloredProductsApiResponse) {
            this.$store.commit('product-list/SET_CURRENT_PAGE', coloredProductsApiResponse.current_page);
            this.coloredProducts.last_page = coloredProductsApiResponse.last_page;
        },
        setupLinks() {
            this.linkPrevHref = this.getURL(this.coloredProducts.current_page - 1);
            this.links = this.generateLinks(this.coloredProducts.current_page, this.coloredProducts.last_page);
            this.linkNextHref = this.getURL(this.coloredProducts.current_page + 1);
        },
        getURL(pageNumber) {
            // It's better to use vue-router for this kind of stuff
            const urlParser = new URL(window.location);
            urlParser.searchParams.set('page', pageNumber);

            return urlParser.href;
        },
        generateLinks(currentPage, lastPage) {
            const links = [];
            let startMergeRequired = false;
            let endMergeRequired = false;
            if (lastPage > 9) {
                if (currentPage - 5 >= 1) startMergeRequired = true;
                if (currentPage + 5 <= lastPage) endMergeRequired = true;
            }
            for (let page = 1; page <= lastPage; page++) {
                let disabled = false;

                if (!startMergeRequired && endMergeRequired) {
                    if (page > 7 && page < lastPage) {
                        disabled = true;
                        page = lastPage - 1;
                    }
                }

                if (startMergeRequired && !endMergeRequired) {
                    if (page > 1 && page < lastPage - 7) {
                        disabled = true;
                        page = lastPage - 7;
                    }
                }

                if (startMergeRequired && endMergeRequired) {
                    if (page > 1 && page < currentPage - 2) {
                        disabled = true;
                        page = currentPage - 3;
                    }

                    if (page > currentPage + 2 && page < lastPage) {
                        disabled = true;
                        page = lastPage - 1;
                    }
                }
                links.push({
                    href: this.getURL(page),
                    url: this.coloredProducts.links.find(link => link.label == page).url,
                    page,
                    disabled,
                    active: page == currentPage,
                    label: disabled ? '...' : page,
                });
            }

            return links;
        },
        cancelFilters() {
            const filters = {};
            $('html, body').animate({ scrollTop: $('#filterWrapperForScrolling').offset().top }, 'slow');
            for (const key in this.filters) {
                this.$store.commit('product-filters/SET_FILTER', {
                    key: key,
                    value: [],
                });
            }

            this.$root.$emit('filterChanged');
        },
    },
};
</script>

<style lang="scss" scoped>
.page-number {
    cursor: pointer;
}

.shop-pagination .prev-next-text {
    display: none;
}

.vermont .subcategories-top-pagination .shop-pagination .prev-next-text {
    display: inline;
    width: auto !important;
}

.vermont .subcategories-top-pagination .shop-pagination .next,
.vermont .subcategories-top-pagination .shop-pagination .prev {
    width: auto !important;
    max-width: none !important;
}

.vermont .subcategories-top-pagination .shop-pagination .next .prev-next-text {
    padding-right: 10px;
    margin-left: 10px;
}

.vermont .subcategories-top-pagination .shop-pagination .prev .prev-next-text {
    padding-left: 10px;
    margin-right: 10px;
}
</style>
